import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = ["fill"];
const _hoisted_3 = ["fill"];
const _hoisted_4 = ["fill"];
const _hoisted_5 = ["fill"];
const _hoisted_6 = ["fill"];
const _hoisted_7 = ["fill"];
const _hoisted_8 = ["fill"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: $props.width,
    height: $props.height,
    viewBox: `0 0 48 48`,
    fill: "none"
  }, [_createElementVNode("path", {
    d: "M33.2891 38.6592L35.4691 24.1918L38.5551 32.0539L46.907 33.313L33.2891 38.657V38.6592Z",
    fill: $props.color
  }, null, 8, _hoisted_2), _createElementVNode("path", {
    d: "M41.5801 27.048L31.6289 16.3232L39.7013 18.8131L45.8926 13.0682L41.5801 27.048Z",
    fill: $props.color
  }, null, 8, _hoisted_3), _createElementVNode("path", {
    d: "M37.6708 13.3282L23.082 14.4204L30.06 9.66154L29.4294 1.23813L37.6708 13.3261V13.3282Z",
    fill: $props.color
  }, null, 8, _hoisted_4), _createElementVNode("path", {
    d: "M24.5067 7.83256L16.2653 19.9205L16.8959 11.4971L9.91797 6.73819L24.5067 7.83039V7.83256Z",
    fill: $props.color
  }, null, 8, _hoisted_5), _createElementVNode("path", {
    d: "M12.002 14.6957L16.3145 28.6755L10.1231 22.9306L2.05078 25.4205L12.002 14.6957Z",
    fill: $props.color
  }, null, 8, _hoisted_6), _createElementVNode("path", {
    d: "M9.57031 28.7535L23.1882 34.0975L14.8363 35.3566L11.7504 43.2187L9.57031 28.7535Z",
    fill: $props.color
  }, null, 8, _hoisted_7), _createElementVNode("path", {
    d: "M19.0469 39.4176L31.7156 32.1038L27.492 39.4176L31.7156 46.7315L19.0469 39.4176Z",
    fill: $props.color
  }, null, 8, _hoisted_8)], 8, _hoisted_1);
}